export default "__VITE_ASSET__DZc89C5L__"